import type { FieldErrors, FieldPath } from 'react-hook-form';

import type { RiderFormValues } from '../types';
import { SECTION_KEYS, SectionKey } from '../types';

export const sectionFieldsBySection: Record<SectionKey, FieldPath<RiderFormValues>[]> = {
  'basic-info': [
    'firstName',
    'lastName',
    'dateOfBirth',
    'gender',
    'email',
    'mobilePhoneNumber',
    'photosAttributes',
    'category',
    'externalId',
    'invoiceGroupId',
    'isAide',
    'isSharedBillingRider',
    'sharedBillingRider',
  ],
  contacts: ['contacts'],
  locations: ['locationDrafts'],
  'rider-services': ['codeWord', 'frontSeatAuthorized', 'boosterSeat', 'services', 'supportSettings', 'riderNotes'],
};

export const findFirstErrorSection = (errors: FieldErrors<RiderFormValues>): SectionKey | null => {
  for (const key of SECTION_KEYS) {
    const hasError = sectionFieldsBySection[key].some((path) => {
      const segment = path.split('.')[0] as keyof RiderFormValues;

      return errors[segment] != null;
    });

    if (hasError) {
      return key;
    }
  }

  return null;
};
